import { render } from "./ItemRequestForm.vue?vue&type=template&id=4a2465f0&scoped=true"
import script from "./ItemRequestForm.vue?vue&type=script&lang=js"
export * from "./ItemRequestForm.vue?vue&type=script&lang=js"

import "./ItemRequestForm.vue?vue&type=style&index=0&id=4a2465f0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2465f0"]])

export default __exports__